import React, { useState } from 'react';
import { parseCoordinates, formatLabel } from '../../utils/coordinateParser';
import { Input } from '../Common/Input';
import { Advice } from '../Common/Card';
import Tabs from '../Common/Tabs';
import AddressInput from '../Common/AddressInput';
import { FormLabelWInfo, FormLabel } from '../Common/Dialog';

const LocationDefForm = ({
  formData,
  setFormData,
  locationInputMode,
  setLocationInputMode,
  initialLocationParts,
  info,
  onInvalid,
  onInput,
  validateRef,
}) => {
  const coordinateInput = formData?.coordinateString ?? '';
  const [locationNameTouched, setLocationNameTouched] = useState(false);
  const locationNameError = locationNameTouched && !formData.locationName.trim();

  return (
    <div className="modal-content">        
      <div className="modal-content__inner">
        <div className="modal-content__inner-block">
          <FormLabelWInfo htmlFor="locationName" text={info.locationName} error={locationNameError}>Ortsbezeichnung</FormLabelWInfo>
          <Input
            id="locationName"
            value={formData.locationName}
            onChange={(e) => setFormData(prev => ({ ...prev, locationName: e.target.value }))}
            onBlur={() => setLocationNameTouched(true)}
            placeholder="z.B. Zentrum Paul Klee"
            required
            className={`${locationNameError ? 'input--error' : ''} text__input`}
            onInvalid={onInvalid}
            onInput={onInput}
          />
        </div>
        <div className="modal-content__inner-block">
          <FormLabelWInfo htmlFor="locationInputMode" text={info.locationAddress}>Standort-Eingabe</FormLabelWInfo>
          <Tabs
            orientation="horizontal"
            tabs={[
              {
                label: 'Adresse',
                onClick: () => {
                  setLocationInputMode('address');
                  // Strasse/PLZ/Ort aus den DB-Werten wiederherstellen, damit die
                  // Felder befüllt sind (auch falls der Koordinaten-Tab sie geleert hat).
                  setFormData(prev => ({
                    ...prev,
                    latitude: '',
                    longitude: '',
                    locationStreet: initialLocationParts?.locationStreet ?? '',
                    locationPlz: initialLocationParts?.locationPlz ?? '',
                    locationCity: initialLocationParts?.locationCity ?? '',
                  }));
                }
              },
              {
                label: 'Koordinaten',
                onClick: () => {
                  setLocationInputMode('coordinates');
                  setFormData(prev => ({ ...prev, locationStreet: '', locationPlz: '', locationCity: '' }));
                }
              }
            ]}
            activeIndex={locationInputMode === 'address' ? 0 : 1}
          />
        </div>
        {locationInputMode === 'address' && (
          <div className="modal-content__inner-block">
            <AddressInput
              className="modal-content__inner-block"
              street={formData.locationStreet}
              plz={formData.locationPlz}
              city={formData.locationCity}
              onChange={({ street, plz, city }) =>
                setFormData(prev => ({
                  ...prev,
                  locationStreet: street,
                  locationPlz: plz,
                  locationCity: city,
                }))
              }
              onValidationChange={(status, coords) => {
                if (status === 'valid' && coords) {
                  setFormData(prev => ({
                    ...prev,
                    latitude: String(coords.lat),
                    longitude: String(coords.lng),
                  }));
                }
              }}
              validateRef={validateRef}
              required={locationInputMode === 'address'}
              onInvalid={onInvalid}
              onInput={onInput}
            />            
            <Advice text="Bei dieser Variante wird die Position aus der Adresse bestimmt." />
          </div>
        )}
        {locationInputMode === 'coordinates' && (
          <div className="modal-content__inner">
            <div className="modal-content__inner-block">
            <FormLabel htmlFor="coordinateString" text={info.locationAddress}>Koordinaten</FormLabel>
            <Input
              id="coordinateString"
              className="text__input"
              type="text"
              value={coordinateInput}
              onChange={(e) => {
                const val = e.target.value;
                const parsed = parseCoordinates(val);
                setFormData(prev => ({
                  ...prev,
                  coordinateString: val,
                  latitude: parsed ? String(parsed.lat) : '',
                  longitude: parsed ? String(parsed.lng) : '',
                }));
              }}
              placeholder={'z.B. 47.4979, 8.7241  |  47°29\'52"N 8°43\'24"E  |  2699163, 1261335'}
              required={locationInputMode === 'coordinates'}
            />
            {coordinateInput.trim() !== '' && (() => {
              const parsed = parseCoordinates(coordinateInput);
              if (parsed) {
                return (
                  <p className="text-sm text-green-600 mt-1">
                    Erkannt: {formatLabel(parsed.format)} → {parsed.lat}, {parsed.lng}
                  </p>
                );
              }
              return (
                <p className="text-sm Colors-Red mt-1">
                  Format nicht erkannt. Bitte WGS84 Dezimal, DMS oder LV95 eingeben.
                </p>
              );
            })()}
            </div>
            {!coordinateInput.trim() && (
              <Advice text="Unterstützte Formate: WGS84 Dezimal, WGS84 Grad/Min/Sek, LV95" />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default LocationDefForm;
